import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Card, {CardHeader, CardFooter} from 'UI/Card';
import Badge from 'UI/Badge';

import ShareDialog from "../ShareDialog";
import StoryCardSettingsMenu from "../StoryCardSettingsMenu";
import StorySettingsDialog from "Components/StorySettingsDialog";
import PublishStoryModal from "Components/PublishStoryModal";
import DuplicateStoryModal from "Components/DuplicateStoryModal";

import { BriefcaseIcon, EyeIcon, LockClosedIcon } from "@heroicons/react/solid";
import ModalConfirm from "../../ui/ModalConfirm";
import StoryCardSlideList from "Components/StoryCard/StoryCardSlideList";

export default class StoryCard extends React.Component
{
    state = {
        showShareModal: false,
        showDeleteModal: false,
        showSettingsModal: false,
        showPublishModal: false,
        showDuplicateModal: false,
    };

    static propTypes = {
        story: PropTypes.object.isRequired,
        removeStory: PropTypes.func.isRequired,
        duplicate: PropTypes.func.isRequired,
        projects: PropTypes.array
    };

    static defaultProps = {
        projects: []
    };

    render()
    {
        const { story } = this.props;

        const { showShareModal, showDeleteModal, showSettingsModal, showPublishModal, showDuplicateModal } = this.state;

        const actions = <StoryCardSettingsMenu
            story={story}
            onSettings={() => this.setState({showSettingsModal: true})}
            onCreatePosts={() => this.setState({showShareModal: true})}
            onPublish={() => this.setState({showPublishModal: true})}
            onDuplicate={() => this.setState({showDuplicateModal: true})}
            onDelete={() => this.setState({showDeleteModal: true})}
        />;

        const title = <Link to={`/stories/${story.id}/edit`} className='hover:underline'>
            {story.name}
        </Link>

        const projects = <div className='-ml-2 truncate'>
            {
                this.props.projects.map(
                    project => <Badge className='ml-2 mt-2' colour={project.colour} key={project.id} small type='primary'>{project.name}</Badge>
                )
            }
        </div>;

        const header = <CardHeader title={title} action={actions}>
            <p className='text-gray-600 text-sm truncate'>
                { story.description }
            </p>
            { projects }
        </CardHeader>;

        const footer = <CardFooter className='flex flex-row-reverse space-x-2 space-x-reverse'>
            <Badge>
                <BriefcaseIcon className='h-3 w-3' />
                <span className='ml-1'>{this.props.projects.length}</span>
            </Badge>
            {
                this.props.story.published_at
                    ? <Badge><EyeIcon className='h-3 w-3' /></Badge>
                    : <Badge><LockClosedIcon className='h-3 w-3' /></Badge>
            }
        </CardFooter>;

        return <Card header={header} footer={footer}>
            <div className='-mx-4 -my-5 sm:-mx-6'>
                <StoryCardSlideList storyId={this.props.story.id} className='px-4 py-5 sm:px-6' />
            </div>

            <ShareDialog
                open={showShareModal}
                onClose={() => this.setState({showShareModal: false})}
                story={story}
            />

            <StorySettingsDialog
                story={story}
                open={showSettingsModal}
                onClose={() => this.setState({showSettingsModal: false})}
            />

            <PublishStoryModal
                story={story}
                open={showPublishModal}
                onClose={() => this.setState({showPublishModal: false})}
            />

            <ModalConfirm
                danger
                open={showDeleteModal}
                onConfirm={() => this.props.removeStory(story.id)}
                onClose={() => this.setState({showDeleteModal: false})}
            >
                Are you sure you wish to remove this Story?
            </ModalConfirm>

            <DuplicateStoryModal
                danger
                open={showDuplicateModal}
                onConfirm={() => this.props.duplicate(story.id)}
                onClose={() => this.setState({showDuplicateModal: false})}
            />

        </Card>;
    }
}
